/**
 * Shared body scroll lock for modals — preserves scroll position.
 */

let lockCount = 0;
let lockedScrollY = 0;

export function lockBodyScroll() {
	if (lockCount === 0) {
		lockedScrollY = window.scrollY || window.pageYOffset || 0;
		document.body.classList.add('dc-modal-open');
		document.body.style.position = 'fixed';
		document.body.style.top = `-${lockedScrollY}px`;
		document.body.style.left = '0';
		document.body.style.right = '0';
		document.body.style.width = '100%';
	}
	lockCount += 1;
}

export function unlockBodyScroll() {
	if (lockCount === 0) {
		return;
	}

	lockCount -= 1;
	if (lockCount > 0) {
		return;
	}

	document.body.classList.remove('dc-modal-open');
	document.body.style.position = '';
	document.body.style.top = '';
	document.body.style.left = '';
	document.body.style.right = '';
	document.body.style.width = '';
	window.scrollTo(0, lockedScrollY);
}

export function focusWithoutScroll(el) {
	if (!el || typeof el.focus !== 'function') {
		return;
	}

	try {
		el.focus({ preventScroll: true });
	} catch {
		el.focus();
	}
}
